import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/weak-map';

import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'unistore/react';

import Store from '~/state/Store';
import App from '~/App';
import GlobalStyles from '~/styles/Global';
import Theme from '~/styles/Theme';

const root = document.createElement('div');

ReactDOM.render(
  <Provider store={Store}>
    <ThemeProvider theme={Theme}>
      <Fragment>
        <GlobalStyles />
        <App />
      </Fragment>
    </ThemeProvider>
  </Provider>,
  root
);

document.body.appendChild(root);
